// Place lowest-priorty scripts here

// Expand toggle (used in Methodology)
import ExpandToggle from './modules/expand-toggle';
document.querySelectorAll('[data-expands]:not(.Intro-toggle)').forEach(el => new ExpandToggle(el));

// Doughnut charts
import DoughnutChart from './modules/doughnut-chart';
document.querySelectorAll('[data-chart="doughnut"]').forEach((el) => new DoughnutChart(el));

// Line charts
import LineChart from './modules/line-chart';
document.querySelectorAll('[data-chart="line"]').forEach((el) => new LineChart(el));

// Tabs
import Tabs from './modules/tabs';
document.querySelectorAll('[data-tabs]').forEach(el => new Tabs(el));

// Moments of joy carousel
import JoyCarousel from './modules/joy-carousel';
const joyCarouselEl = document.querySelector('.Joy-carousel');
if (joyCarouselEl) {
  new JoyCarousel(joyCarouselEl);
}
